import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-side-panel-dialog-title',
  templateUrl: './side-panel-dialog-title.component.html',
  styleUrl: './side-panel-dialog-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidePanelDialogTitleComponent {}
